var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CvView view vhSpace vhSpace--large"},[(_vm.app.gui.view == 'CvIntro')?[_c('CvIntro')]:_vm._e(),(_vm.app.gui.view == 'CvSheet')?[_c('CvSheet')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }